module.exports = __webpack_public_path__ + "img/douyin_qrcode.43c68426.png";